import YoungPeopleView from './YoungPeopleViewContainer';
export default YoungPeopleView;
